import { PropTableValues } from "../../../../src/components";
import { iconColors, namedIconSizes, numericIconSizes } from '@primer/react-brand';
import * as React from 'react';
export default {
  PropTableValues,
  iconColors,
  namedIconSizes,
  numericIconSizes,
  React
};